import { render, staticRenderFns } from "./DeleteTag.vue?vue&type=template&id=67f59d6c&scoped=true&"
import script from "./DeleteTag.vue?vue&type=script&lang=js&"
export * from "./DeleteTag.vue?vue&type=script&lang=js&"
import style0 from "./DeleteTag.vue?vue&type=style&index=0&id=67f59d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f59d6c",
  null
  
)

export default component.exports